
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getUpdateProjectNotesDtoFormGroup() {
return new FormGroup({
    tobNotes: new FormControl<string | undefined>(undefined),
    calculationNotes: new FormControl<string | undefined>(undefined),
    offerBasedOnDescription: new FormControl<string | undefined>(undefined),
    duration: new FormControl<number | undefined>(undefined),
    durationUnitId: new FormControl<number | undefined>(undefined),
})
;
}
      